// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-main[data-v-48e56da9] {\n  padding: 10px;\n}\n.app-main .el-form-item[data-v-48e56da9] {\n  margin-bottom: 0;\n}", ""]);
// Exports
module.exports = exports;
